export const URLS = {
    DIBIMAGES_ROOT: "https://static.dib.no/",
    KONTOHJELP: "https://kontohjelp.no/",
    REGNSKAPSANALYSE: "/regnskapsanalyse",
    SUPPORT: "https://support.dib.no/",
    ADMIN: "https://kundeadmin.dib.no",
    CHANGE_PASSWORD: "https://login.dib.no/dib/endrepassord",
    KOSTRAHJELP: "https://kostrahjelp.no/",
    DOKUMENTFLYT: "https://app.dflow.com/",
    KAI: "https://ai.dib.no/",
};
